module.exports = __webpack_public_path__ + "img/Pinterest.98580f0d.png";